module.exports = __webpack_public_path__ + "img/nus-works.a14fa26d.png";